module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBmaWxsPSIjMkMzRTUwIiB3aWR0aD0iMTAwcHQiIGhlaWdodD0iMTAwcHQiIHZlcnNpb249IjEuMSIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiA8cGF0aCBkPSJtNTMuNSA1MCAyNS41LTI1LjVjMS0xIDEtMi42MDE2IDAtMy41cy0yLjYwMTYtMS0zLjUgMGwtMjUuNSAyNS41LTI1LjUtMjUuNWMtMS0xLTIuNjAxNi0xLTMuNSAwLTEgMS0xIDIuNjAxNiAwIDMuNWwyNS41IDI1LjUtMjUuNSAyNS41Yy0xIDEtMSAyLjYwMTYgMCAzLjUgMSAxIDIuNjAxNiAxIDMuNSAwbDI1LjUtMjUuNSAyNS41IDI1LjVjMSAxIDIuNjAxNiAxIDMuNSAwIDEtMSAxLTIuNjAxNiAwLTMuNXoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 128
// module chunks = 1